import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import QRCode from 'react-qr-code';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode } from '@fortawesome/pro-regular-svg-icons/faQrcode';
import { getLang } from 'shared/store/selectors/lang.selector';
import { buildCheckInUrl } from 'shared/utils/check-in-url';
import monitorService from 'src/helpers/monitor.service';
import { useTotpCode } from '../../helpers/use-totp-code';
import styles from './check-in.module.scss';

function CheckInQr({ url }) {
  const lang = useSelector(getLang('EDUCATIONAL_EVENTS'));

  if (!url) {
    return (
      <div className={styles.qrPlaceholder} aria-hidden="true">
        <FontAwesomeIcon icon={faQrcode} className={styles.qrPlaceholderIcon} />
      </div>
    );
  }

  return (
    <div className={styles.qr} role="img" aria-label={lang.SCAN_TO_CHECK_IN}>
      <QRCode value={url} className={styles.qrCode} />
    </div>
  );
}

function RotatingQrCheckInCard({ eventId, totpSecret, step }) {
  const lang = useSelector(getLang('EDUCATIONAL_EVENTS'));
  const { code, error } = useTotpCode(totpSecret, { step });

  useEffect(() => {
    if (error) monitorService.error('Failed to generate check-in TOTP code', { error });
  }, [error]);

  if (error) {
    return <p className={styles.qrError}>{lang.QR_CODE_FAILED}</p>;
  }

  return <CheckInQr url={code && eventId ? buildCheckInUrl({ eventId, code }) : null} />;
}

export function QrCheckInCard({ eventId, isStatic, totpSecret, step }) {
  if (isStatic) {
    return <CheckInQr url={eventId ? buildCheckInUrl({ eventId }) : null} />;
  }
  return <RotatingQrCheckInCard eventId={eventId} totpSecret={totpSecret} step={step} />;
}
